import App from "../App";
import Calculator from "./Calculator";
import Download from "./Download";
import Header from "./Header";
import Admin from "./admin";
import PrivacyPolicy from "./privacypolicy";
import Support from "./support";
import { Routes, Route } from "react-router-dom";

function Home() {
  return (
    <div>
      <Header />
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/support" element={<Support />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/aly" element={<Admin />} />
        <Route path="/download" element={<Download />} />
        <Route path="/Calculator" element={<Calculator />} />
      </Routes>
    </div>
  );
}

export default Home;
